import { TIME_IN_MS } from 'constants/dateTime';
import { isNan } from 'helpers/utils';

/**
 * @description
 * Function to check all values of array are non false number
 * @param {unknown[]} arr - array of any value
 */

const allNumbersNonZeroAndValid = (arr: unknown[]) => {
  if (arr.length === 0) {
    return false;
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < arr.length; ++i) {
    if (isNan(arr[i]) || Object.is(arr[i], -0) || Object.is(arr[i], 0)) {
      return false;
    }
  }
  return true;
};

// todo: should return minutes for 1 minute - GROW-3864
/** @param {number} time - should be in seconds */
const getBlockedTime = (
  time: number
): { value: number; unit: 'hour' | 'hours' | 'minutes' } => {
  const timeInMs = time * TIME_IN_MS.ONE_SECOND;

  if (timeInMs >= TIME_IN_MS.ONE_HOUR) {
    return {
      value: Math.ceil(timeInMs / TIME_IN_MS.ONE_HOUR),
      unit: timeInMs === TIME_IN_MS.ONE_HOUR ? 'hour' : 'hours',
    };
  }
  return { value: Math.ceil(timeInMs / TIME_IN_MS.ONE_MINUTE), unit: 'minutes' };
};

/** @description returns floor and ceil values and index (null if not found) in an array for a given value, */
const findFloorAndCeilForNumber = (arr: number[], value: number) => {
  let floorValue = Number.MIN_SAFE_INTEGER;
  let floorIndex = -1;
  let ceilIndex = -1;
  let ceilValue = Number.MAX_SAFE_INTEGER;

  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i] > floorValue && arr[i] < value) {
      floorValue = arr[i];
      floorIndex = i;
    }
    if (arr[i] < ceilValue && arr[i] > value) {
      ceilValue = arr[i];
      ceilIndex = i;
    }
  }

  return {
    floorData: floorValue === Number.MIN_SAFE_INTEGER ? null : { floorIndex, floorValue },
    ceilData: ceilValue === Number.MAX_SAFE_INTEGER ? null : { ceilIndex, ceilValue },
  };
};

const findClosestSmallerNumberInArray = (numbers: number[], target: number) => {
  if (!numbers.length || isNan(target)) return null;

  // Sort numbers in ascending order
  const sortedNumbers = [...numbers].sort((a, b) => a - b);

  // Find the largest number that's less than or equal to the target
  return sortedNumbers.reduce((closest, current) => {
    if (current <= target && current > closest) {
      return current;
    }
    return closest;
  }, -Infinity);
};

export {
  allNumbersNonZeroAndValid,
  getBlockedTime,
  findFloorAndCeilForNumber,
  findClosestSmallerNumberInArray,
};
